import {fetchRequest} from './fetchRequest';

export const access = ()=>{
    return fetchRequest({
        url:'access',
    });
};

export const apheresisKits = (et_id)=>{
    return fetchRequest({
        url:'apheresis_kits?et_id='+et_id
    });
};

export const apheresisKitsActive = ()=>{
    return fetchRequest({
        url:'apheresis_kits?option=actives'
    });
};

export const analiticalTestAddTestFromHc = (obj, modal)=>{
    return fetchRequest({
        url:'other_anaitical_test_required/add_test_from_hc',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Agregando...'
    });
};

export const analiticalTestByOffer = (offers_id, modal)=>{
    return fetchRequest({
        url:'other_anaitical_test_required/by_offer?offer_id='+offers_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const analiticalTestDelete = (id)=>{
    return fetchRequest({
        url: 'other_anaitical_test_required/'+id,
        method:'DELETE'
    });
};

export const analiticalTestOption = (option)=>{
    return fetchRequest({
        url:'analitical_test?option='+option
    });
};

export const analiticalTestValues = (test)=>{
    return fetchRequest({
        url:'analitical_test/values?fixed_test='+test
    });
};

export const analiticalProfilePerson = (id)=>{
    return fetchRequest({
        url:'analytic_profile_person/'+id
    });
};

export const analiticalProfilePersonOption = (option)=>{
    return fetchRequest({
        url:'analytic_profile_person?option='+option
    });
};

export const biometricsDataByOffer = (offer_id, type)=>{
    return fetchRequest({
        url:'biometrics_data/by_offer?id='+offer_id+'&form_type='+type
    });
};

export const biometricsDataByOfferCells = (offer_cells_id, type)=>{
    return fetchRequest({
        url:'biometrics_data/by_offer_cells?id='+offer_cells_id+'&form_type='+type
    });
};

export const biometricsOption = (option, sex='')=>{
    return fetchRequest({
        url:'biometrics?option='+option+'&sex='+sex
    });
};

export const biometricsDataSave = (obj, modal)=>{
    return fetchRequest({
        url:'biometrics_data',
        method:'POST',
        obj:obj,
        modal: modal,
        message_modal:'Guardando...'
    });
}

export const bloodBagsByHf = (hf_id)=>{
    return fetchRequest({
        url:'blood_bags/by_hf/'+hf_id
    });
};

export const bloodBagsByHfType = (hf_id, et_id)=>{
    return fetchRequest({
        url:'blood_bags/by_hf/'+hf_id+'/'+et_id
    });
};

export const bloodComponent = (option)=>{
    return fetchRequest({
        url:'blood_component?option='+option
    });
};

export const callerActionsHistory = (obj, modal)=>{
    return fetchRequest({
        url:'caller_actions_history',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Generando...'
    })
}
export const callerActionsHistorySocial = (obj, modal)=>{
    return fetchRequest({
        url:'caller_actions_historySocial',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Generando...'
    })
}

export const callerActionHistory = (hf_id)=>{
    return fetchRequest({
        url:'caller_actions_history?health_facilities_id='+hf_id+'&message=new_offer_added'
    });
};

export const callerActionHistoryListCalled = (hf_id)=>{
    return fetchRequest({
        url:'caller_actions_history?option=list_called&health_facilities_id='+hf_id,
        requireToken:false
    });
};

export const callerActionHistoryInchreaseCalledTimes = (id)=>{
    return fetchRequest({
        url:'caller_actions_history?id='+id+'&ip=&section=null&option=increase_called_times',
        method:'PUT',
        requireToken:false
    });
};

export const callerActionHistoryRelease = (hf_id)=>{
    return fetchRequest({
        url:'caller_actions_history/release?hf_id='+hf_id,
        method:'POST'
    });
};

export const callerActionHistoryVitalSignsTaken = (id)=>{
    return fetchRequest({
        url:'caller_actions_history/vital_signs_taken/'+id,
        method:'PUT'
    });
}

export const callerConfiguration = (id)=>{
    return fetchRequest({url:'caller_configuration/'+id});
}

export const callerConfigurationInitStatus = (id)=>{
    return fetchRequest({url:'caller_configuration/init_status/'+id});
}

export const checkPrintType = (type)=>{
    return fetchRequest({
        url:'html_templates/check_print_type?hf_id='+sessionStorage.getItem('health_facilities_id')+'&file_type='+type,
    });
};

export const clinicHistory = (id, obj, modal)=>{
    return fetchRequest({
        url:'clinic_history'+(id !== '' ? '/'+id : ''),
        method: id !== '' ? 'PUT' : 'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const clinicHistoryPrint = (id, modal)=>{
    return fetchRequest({
        url:"clinic_history/print/"+id,
        method:'POST',
        modal:modal,
        message_modal:'Generando...',
        is_file:true
    });
};

export const clinicHistoryValuesOffer = (id)=>{
    return fetchRequest({
        url: 'clinic_history/by_offer?id='+id
    });
};

export const clinicHistoryValuesOfferCell = (id, modal = null)=>{
    return fetchRequest({
        url: 'clinic_history/by_offering_cell?id='+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const clinicHistoryYearsHasHc = (hf_id)=>{
    return fetchRequest({
        url:'clinic_history/years_has_hc?health_facilities_id='+hf_id
    });
};

export const colorClinicHistory = (option, offer_id, type = 'OFFER') => {
    return fetchRequest({
        url: 'clinic_history?option='+option+'&offer_id='+offer_id+'&type='+type
    });
}

export const convokePlacesOption = (option, hf_id)=>{
    return fetchRequest({
        url:'convoke_places?option='+option+'&health_facilities_id='+hf_id,
    });
};

export const convokePlacesActive = ()=>{
    return fetchRequest({
        url:'convoke_places?option=active'
    });
};

export const dashboardDaylyDonations = ()=>{
    return fetchRequest({
        url:'dashboard/daily_donations?hf_id='+sessionStorage.getItem('health_facilities_id'),
    });
};

export const statisticalSummaryOfDonors = (obj)=>{
    return fetchRequest({
        url:'donors/statistical_summary_donors',
        method:'POST',
        obj: obj,
    });
};

export const dashboardUnitComponentType = ()=>{
    return fetchRequest({
        url:'dashboard/units_by_component_type?hf_id='+sessionStorage.getItem('health_facilities_id'),
    });
};

export const distributionReturned = (obj, modal)=>{
    return fetchRequest({
        url:'distribution_returned',
        method:'POST',
        obj: obj,
        modal: modal,
        message_modal:'Guardando...'
    });
};

export const distributionReturnedGet = (id, modal)=>{
    return fetchRequest({
        url:'distribution_returned/'+id,
        modal: modal,
        message_modal:'Cargando...'
    });
};

export const distributionReturnedList = (start, end, hf_id, modal)=>{
    return fetchRequest({
        url:'distribution_returned?start_date='+start+'&end_date='+end+'&hf_id='+hf_id,
        modal:modal,
        message_modal:'Buscando...'
    });
};

export const distributionReturnedSearch = (start, end, folio, hf_id, modal)=>{
    return fetchRequest({
        url:'distribution_returned/search?start_date='+start+'&end_date='+end+'&folio='+folio+'&hf_id='+hf_id,
        modal:modal,
        message_modal:'Buscando...'
    });
};

export const distributionReturnedSearchByUnit = (unit, hf_id, modal)=>{
    return fetchRequest({
        url:'distribution_returned/search_by_unit_number?unit_number='+unit+'&hf_id='+hf_id,
        modal:modal,
        message_modal:'Buscando...'
    });
};
export const donors_bypatient =(listadopdf,name,hf_id,patient_id)=>{
    return fetchRequest({
        url:"html_templates/donors_bypatient?name="+name+"&hf_id="+hf_id+"&patient_id="+patient_id,
        method:'POST',
        obj:listadopdf,
        message_modal:'Generando...',
        is_file:true
    });
};
export const donationsDonorInfo = (id)=>{
    return fetchRequest({
        url:'donations/donor_info/'+id
    });
};

export const donationsEntryDonation = (hf_id, obj, modal)=>{
    return fetchRequest({
        url:'donations/entry_donation?health_facilities_id='+hf_id,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Generando...'
    });
};

export const donationsExternalDonation = (hf_id, start_date, end_date, start_folio, end_folio, modal)=>{
    return fetchRequest({
        url:'donations/external_donation?health_facilities_id='+hf_id+'&start_date='+start_date+
            '&end_date='+end_date+'&start_folio='+start_folio+'&end_folio='+end_folio,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const donationsGetExternalDonation = (id, modal)=>{
    return fetchRequest({
        url:'donations/get_external_donation?id='+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const donationsGetNextNumber = (hf_id, type)=>{
    return fetchRequest({
        url:'donations/get_next_number?health_facilities_id='+hf_id+'&sample_type='+type
    });
};

export const donationsHf = (hf_id, obj, modal)=>{
    return fetchRequest({
        url:'donations/generate_number?hf_id='+hf_id,
        method:'POST',
        obj, obj,
        modal:modal,
        message_modal:'Generando...'
    });
};

export const donationsId = (id)=>{
    return fetchRequest({
        url:'donations?id='+id
    });
};

export const donationComplementaryId = (id, modal)=>{
    return fetchRequest({
        url:'donation_complementary?donation_id='+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const donationComplementarySave = (id, obj, modal)=>{
    return fetchRequest({
        url:'donation_complementary'+(id !== '' ? '/'+id : ''),
        method:id === '' ? 'POST' : 'PUT',
        obj:obj,
        modal:modal,
        message_modal: id === '' ? 'Guardando...' : 'Actualizando...'
    });
};

export const donationNotes = (obj, modal)=>{
    return fetchRequest({
        url:'donation_notes',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const donationNotesByOffer = (offers_id, actives)=>{
    return fetchRequest({
        url:'donation_notes/by_offer?offers_id='+offers_id+'&actives='+actives
    });
};

export const donationNotesInactive = (id)=>{
    return fetchRequest({
        url:'donation_notes/inactive/'+id,
        method:'POST'
    });
};

export const donationRevalidate = (id)=>{
    return fetchRequest({
        url:'donations/revalidate/'+id,
        method:'POST'
    });
};

//donation_types preoffers
export const donationRules = (id)=>{
    return fetchRequest({
        url:'donation_rules?option=donation_extraction&donation_extraction_id='+id,
    });
};

export const donationsSave = (id, obj, modal)=>{
    return fetchRequest({
        url:'donations/'+id,
        method:'PUT',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const donationTypeActives = ()=>{
    return fetchRequest({
        url:'donation_type/actives'
    });
};

export const donationTypeExtraction = (option)=>{
    return fetchRequest({
        url:'donation_type_extraction?option=' + option,
    });
};

export const donationTypeExtractionId = (id)=>{
    return fetchRequest({
        url:'donation_type_extraction/'+id
    });
};

export const donationsUpdateEntryDonation = (obj, modal)=>{
    return fetchRequest({
        url:'donations/update_entry_donation',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};


export const donors = (id, offer_id, modal = null)=>{
    return fetchRequest({
        url:'donors?id='+id+'&offer_id='+offer_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const donorBasicInfo = (id)=>{
    return fetchRequest({
        url:'donors/basic_info/'+id
    });
};

export const donorsGetDonations = (id, modal)=>{
    return fetchRequest({
        url:'donors/get_donations?donor_id='+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const donorHcData = (id, type, modal=null)=>{
    return fetchRequest({
        url:'donors/hc_data?id='+id+'&type='+type,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const donorsId = (id)=>{
    return fetchRequest({
        url:'donors/'+id
    });
};

export const donorsLoadDonor = (id)=>{
    return fetchRequest({
        url:'donors?option=loadDonor&donor_id='+id
    });
};



export const donorsSearch = (query)=>{
    return fetchRequest({
        url:'donors?search='+query
    });
};

export const donorsSecondSample = (id)=>{
    return fetchRequest({
        url:'donors_second_sample/'+id
    });
};

export const donorsSecondSampleDelete = (id)=>{
    return fetchRequest({
        url:'donors_second_sample/'+id,
        method:'DELETE'
    });
}

export const equipments = (type)=>{
    return fetchRequest({
        url:'equipments?type='+type
    });
};

export const equipmentsActives = (type)=>{
    return fetchRequest({
        url:'equipments/actives?type='+type
    });
};

export const facilitySectionsDonors = (id)=>{
    return fetchRequest({
        url:'facility_sections?health_facility_id='+id+'&x=donors',
    });
};

export const fieldSettings = (key)=>{
    return fetchRequest({
        url:'field_settings?form_key='+key
    });
};

export const formularioId = (form_id, sex)=>{
    return fetchRequest({
        url:'Formulario/render?form_id='+form_id+'&person_sex='+sex
    });
};

export const formularioRender = (hf_id, sex, donor, et_id)=>{
    return fetchRequest({
        url:'Formulario/render?hf_id='+hf_id+'&person_sex='+sex+'&for_donors='+donor+'&et_id='+et_id
    });
};

export const functionalCriterial = (code)=>{
    return fetchRequest({
        url:'functional_criterion?code='+code,
    });
};

export const generateExcelImss = (type, obj, modal)=>{
    return fetchRequest({
        url:'reports_imss/generate_excel?report_name=' + type,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Generando...',
        is_file:true,
    });
};

export const generatePdfImss = (type, obj, modal)=>{
    return fetchRequest({
        url:'reports_imss/generate_pdf?report_name=' + type,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Generando...',
        is_file:true,
    });
};

export const getColumnsList = (search)=>{
    return fetchRequest({
        url: 'list_show?option=list_key&search='+search,
    });
};

export const getDateHour = ()=>{
    return fetchRequest({
        url:'offers?option=date',
    });
};

export const getLineUnitRequest = ()=>{
    return fetchRequest({
        url:'unit_request/pending?hf_id='+sessionStorage.getItem("health_facilities_id"),
    });
};

export const getLineWarehouse = ()=>{
    return fetchRequest({
        url:'units/get_unit_expired?hf_id='+sessionStorage.getItem("health_facilities_id")+'&option=x',
    });
};
export const getofferbydonornumber = (donor_number,hf_id)=>{
    return fetchRequest({
        url:'offers/getoffer/donor?donor_number='+donor_number+'&hf_id='+hf_id
    });
};
export const getPermissions = ()=>{
    return fetchRequest({
        url:"access?health_facilities_id="+sessionStorage.getItem("health_facilities_id"),
    });
};

export const getUserGeneric = ()=>{
    return fetchRequest({
        url:'users_generic/'+sessionStorage.getItem("generic_session_id"),
        method:'PUT',
    });
};

export const getUserIp = ()=>{
    return fetchRequest({
        url:'users/getIP',
        requireToken:false
    });
};

//sites offers
export const healthFacilities = ()=>{
    return fetchRequest({
        url:'health_facilities'
    });
};

export const healthFacilitiesGetCriterial = (hf_id, code)=>{
    return fetchRequest({
        url:'health_facilities/get_criterial?hf_id='+hf_id+'&code='+code
    });
};

export const healthFacilitiesId = (id, modal)=>{
    return fetchRequest({
        url:'health_facilities/'+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const healthFacilitiesExcluded = (hf_id)=>{
    return fetchRequest({
        url:'health_facilities/exclude?hf_id='+hf_id
    });
};

export const healthFacilitiesOption = (option)=>{
    return fetchRequest({
        url:'health_facilities?option='+option
    });
};

export const healthFacilitiesUnitRequest = (hf_id)=>{
    return fetchRequest({
        url:'health_facilities/unit_request?health_facility_id='+hf_id
    });
};

export const hl7ImssSearchPersonIdee = (idee, hf_id, complete, modal)=>{
    return fetchRequest({
        url:'hl7_imss/search_person?idee='+idee+'&hf_id='+hf_id+'&complete='+complete,
        modal:modal,
        message_modal:'Buscando...'
    });
};

export const hl7ImssSearchPersonNss = (nss, medicalAttache, hf_id, complete, modal)=>{
    return fetchRequest({
        url:'hl7_imss/search_person?nss='+nss+'&agregado_medico='+medicalAttache+'&hf_id='+hf_id+'&complete='+complete,
        modal:modal,
        message_modal:'Buscando...'
    });
};

export const htmlTemplates = (hf_id, file_type, extraction_type = '')=>{
    return fetchRequest({
        url:'html_templates?health_facilities_id='+hf_id+'&file_type='+file_type+'&extraction_type='+extraction_type
    });
};

export const htmlTemplatesPrintResultsInBulk = (obj, modal)=>{
    return fetchRequest({
        url:'html_templates/print_results_in_bulk',
        method:'POST',
        obj:obj,
        is_file:true,
        modal:modal,
        message_modal:'Imprimiendo...'
    });
};

export const htmlTemplatesPrintExternal = (obj)=>{
    return fetchRequest({
        url:'html_templates/print_external',				
        method:'POST',
        obj:obj,
        is_file:true,
    });
};

export const htmlTemplatePrintDocument = (obj)=>{
    return fetchRequest({
        url:'html_templates/print_document',
        method:'POST',
        obj:obj,
        is_file:true,
    });
};

export const htmlTemplatePrintListaAgenda = (obj,hf_id)=>{
    return fetchRequest({
        url:'html_templates/printAgenda/'+hf_id,
        method:'POST',
        obj:obj,
        is_file:true,
    });
};

export const incidentsExtractionId = (id)=>{
    return fetchRequest({
        url:'incidents_extraction?id='+id
    });
};

export const incidentsOption = (option)=>{
    return fetchRequest({
        url:'incidents?option='+option
    });
};

export const incidentsSave = (id, obj, modal)=>{
    return fetchRequest({
        url:'incidents_extraction'+(id !== '' ? '/'+id : ''),
        method: id === '' ? 'POST' : 'PUT',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const labSectionsByHf = (id)=>{
    return fetchRequest({
        url:'lab_sections/by_health_facility?id='+id
    });
};

export const logout = ()=>{
    return fetchRequest({
        url:'users/log_out',
        method:'POST',
    });
};

export const lookAndFeel = ()=>{
    return fetchRequest({
        url:'look_and_feel',
        requireToken:false
    });
};

export const lookAndFeelByHfId = (id)=>{
    return fetchRequest({
        url:'look_and_feel/by_hf/'+id
    });
}

export const lookups = (type, order)=>{
    return fetchRequest({
        url:'lookups?type='+type+'&option=actives&order='+order,
    });
}

export const lookupsLevel2 = (type, option)=>{
    return fetchRequest({
        url:'lookups_level2?type='+type+'&option='+option,        
    });
};

export const lookupsNotRender = (type)=>{
    return fetchRequest({
        url:'lookups?type='+type+'&notrender=0'
    });
};

export const lookupsOrderBy = (type)=>{
    return fetchRequest({
        url:'lookups/order_by?type='+type+'&option=name',
    });
}

export const lookupsType = (type)=>{
    return fetchRequest({
        url:'lookups?type='+type
    });
};

export const medicalNotes = (section, key)=>{
    return fetchRequest({
        url:'medical_notes?section_type='+section+'&note_type='+key
    });
};

export const medicalStaffOption = (option)=>{
    return fetchRequest({
        url:'medical_staff?option='+option+'&type=NURSE'
    });
};

export const monitoringMedicalNotes = (id, type)=>{
    return fetchRequest({
        url:'monitoring_medical_notes?monitoring_id='+id+'&type='+type
    });
};

export const monitoringMedicalNotesSave = (id, obj, modal)=>{
    return fetchRequest({
        url:'monitoring_medical_notes/'+id,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const monitoringTraceability = (obj)=>{
    return fetchRequest({
        url:'monitoring_traceability',
        method:'POST',
        obj:obj
    });
}

export const nationalCenter = ()=>{
    return fetchRequest({
        url:'national_centers'
    });
};

export const nationalCenterActive = ()=>{
    return fetchRequest({
        url:'national_centers?option=active'
    });
};

export const nationalCentersOption = (hf_id, option)=>{
    return fetchRequest({
        url:'national_centers?option='+option+'&health_facility='+hf_id
    });
};

export const newSingleRecord = (obj, modal)=>{
    return fetchRequest({
        url: 'caller_actions_history',
        obj: obj,
        method: 'POST',
        modal: modal,
        message_modal: 'Generando...'
    });
};

export const offersBioList = (start_date, end_date, hf_id, bio_type)=>{
    return fetchRequest({
        url:'offers/bio_list?start_date='+start_date+'&end_date='+end_date+'&hf_id='+hf_id+'&bio_type='+bio_type
    });
};

export const offersDaysAfterRegister = (offers_id)=>{
    return fetchRequest({
        url:'offers/days_after_register?offers_id='+offers_id
    });
};

export const offersDelete = (id, modal)=>{
    return fetchRequest({
        url:'offers/'+id,
        method:'DELETE',
        modal:modal,
        message_modal:'Eliminando...'
    });
};

export const offersId = (offers_id)=>{
    return fetchRequest({
        url:'offers/'+offers_id
    });
};

export const offersList = (url)=>{
    return fetchRequest({ url: url });
};

export const offeringCellsId = (id)=>{
    return fetchRequest({
        url:'offering_cells/'+id
    });
};

export const offeringCellsDelete = (id) => {
    return fetchRequest({
        url:'offering_cells/'+id,
        method: 'DELETE'
    })
};

export const offeringCellsList =(et_id, hf_id, date_ini, date_end, modal = null) => {
    return fetchRequest({
        url:'offering_cells?extraction_type_id='+et_id+'&hf_id='+hf_id+'&date_ini='+date_ini+'&date_end='+date_end,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const offeringCellsSave = (obj, modal)=>{
    return fetchRequest({
        url:'offering_cells',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const offeringCellsUpdate = (id, obj, modal)=>{
    return fetchRequest({
        url:'offering_cells/'+id,
        method:'PUT',
        obj:obj,
        modal:modal,
        message_modal:'Actualizando...'
    });
};

export const offeringMedicalNotes = (id, type, modal = null)=>{
    return fetchRequest({
        url:'offering_medical_notes?offerin_cell_id='+id+'&type='+type,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const offeringMedicalNotesSave = (id, obj, modal)=>{
    return fetchRequest({
        url:'offering_medical_notes/'+id,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const patientOffer = (id)=>{
    return fetchRequest({
        url:'patients/patient_offer?id='+id
    });
};

export const personSearch = (query)=>{
    return fetchRequest({
        url:'person?search='+query
    });
};

export const petitionsApheresisValues = (id)=>{
    return fetchRequest({
        url:'petitions/apheresis_values/'+id
    });
};

export const petitionMedicalNotesGet = (id, key)=>{
    return fetchRequest({
        url:'petition_medical_notes?petition_id='+id+'&type='+key
    });
};

export const petitionMedicalNotesPost = (id, obj, modal)=>{
    return fetchRequest({
        url:'petition_medical_notes/'+id,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const plasmaticProductRequestDelete = (unit, modal)=>{
    return fetchRequest({
        url:'plasmatic_product_request/'+unit,
        method:'DELETE',
        modal:modal,
        message_modal:'Borrando...'
    });
};

export const plasmaticProductRequestStatus = (unit, status, modal)=>{
    return fetchRequest({
        url:'plasmatic_product_request/'+unit+'/'+status,
        method:'PUT',
        modal:modal,
        message_modal:'Cancelando...'
    });
};

//pre_offers
export const preOffers = (id)=>{
    return fetchRequest({
        url: 'pre_offers/'+id
    });
};

export const preOffersDelete = (id)=>{
    return fetchRequest({
        url: 'pre_offers/'+id,
        method:'DELETE'
    });
};

export const preOffersFields = (convoke_place, extraction_type)=>{
    var url = 'pre_offer_fields/sections?cp_id='+convoke_place+'&et_id='+extraction_type;
    return fetchRequest({
        url: url
    });
};

export const preOffersGet = (modal)=>{
    return fetchRequest({
        url:'pre_offers',
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const preOffersList = (option, start_date,end_date, startHour, endHour, hf_id, convoke_place, extraction_type, modal)=>{
    var url = "";

    if(option === "all"){
        url = 'pre_offers/all?date='+start_date+'&end_date='+end_date+'&hf_id='+hf_id;
    }else{
        url = 'pre_offers?start_date='+start_date+' '+startHour+
                '&end_date='+end_date+' '+endHour+'&hf_id='+hf_id;
    }

    url += '&cp_id=' + convoke_place + '&et_id=' + extraction_type;

    return fetchRequest({
        url: url,
        modal:modal,
        message_modal:'Cargando...',
    });
};

export const preOffersNextNumber = (date)=>{
    return fetchRequest({
        url: 'pre_offers/next_number?date='+date
    });
};

export const preOffersSave = (flagEdit, id, obj, modal)=>{
    return fetchRequest({
        url: flagEdit ? "pre_offers/"+id : "pre_offers",
        method: flagEdit ? "PUT" : "POST",
        obj: obj,
        modal: modal,
        message_modal:'Guardando...'
    });
};

export const preOffersSearch = (start_date, convoke_place, extraction_type)=>{
    var url = 'pre_offer_days?date=' + start_date+'&cp_id=' + convoke_place+'&et_id=' + extraction_type;
    return fetchRequest({
        url: url
    });
};

export const printLabel = (obj)=>{
    return fetchRequest({
        url:'labelsEditor',
        method:'POST',
        obj:obj,
        is_file:true,
    });
};

export const printingBlock = (type, hf_id, start_date, end_date, start_folio, end_folio, convoke_place_id, modal)=>{
    return fetchRequest({
        url:type+'/to_print?hf_id='+hf_id+'&start_date='+start_date+'&end_date='+end_date+'&start_folio='+start_folio+'&end_folio='+end_folio+'&convoke_place='+convoke_place_id,
        modal:modal,
        message_modal:'Buscando...'
    });
};

export const qualityControlCheck = ()=>{
    return fetchRequest({
        url:'quality_control/check?hf_id='+sessionStorage.getItem('health_facilities_id'),
    });
};

export const rejectReasons = (option)=>{
    return fetchRequest({
        url:'rejection_reasons?option='+option
    });
};

export const samplesByOfferingCells = (id)=>{
    return fetchRequest({
        url:'samples/by_offering_cell?id='+id
    });
};

export const samplesCreateSample = (hf_id, donor, obj, modal)=>{
    return fetchRequest({
        url:'samples/create_sample?health_facilities_id='+hf_id+'&donor_id='+donor,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const samplesDelete = (id)=>{
    return fetchRequest({
        url:'samples/'+id,
        method:'DELETE'
    });
};

export const samplesDetails = (id)=>{
    return fetchRequest({
        url:'samples/details/'+id
    });
};

export const samplesGetNextNumber = (hf_id, sample_type)=>{
    return fetchRequest({
        url:'samples/get_next_number?health_facilities_id='+hf_id+'&sample_type='+sample_type
    });
};

export const samplesLabInfo = (id, modal)=>{
    return fetchRequest({
        url:'samples/lab_info/'+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const samplesOfferingCellsSave = (obj, modal)=>{
    return fetchRequest({
        url:'samples/offering_cell',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const samplesOfferingCellsUpdate = (id, obj, modal)=>{
    return fetchRequest({
        url:'samples/offering_cell/'+id,
        method:'PUT',
        obj:obj,
        modal:modal,
        message_modal:'Actualizando...'
    });
};

export const sampleResultsSave = (id, obj, modal)=>{
    return fetchRequest({
        url:'sample_results/'+id,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const samplesRegister = (hf_id, start_date, end_date, start_folio, end_folio, modal)=>{
    return fetchRequest({
        url:'samples/samples_register?health_facilities_id='+hf_id+'&start_date='+start_date+
            '&end_date='+end_date+'&start_folio='+start_folio+'&end_folio='+end_folio,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const samplesShow = (id)=>{
    return fetchRequest({
        url:'samples/show?id='+id
    });
};

export const sampleTypes = ()=>{
    return fetchRequest({
        url:'sample_types'
    });
};

export const samplesUpdateSample = (id, obj, modal)=>{
    return fetchRequest({
        url:'samples/update_sample?donor_id='+id,
        method:'PUT',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const secondSample = (obj, modal)=>{
    return fetchRequest({
        url:'donors_second_sample',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando'
    });
};

export const shippingSamples = (start_date, end_date, hf_id, modal)=>{
    return fetchRequest({
        url:'shipping_samples?start_date='+start_date+'&end_date='+end_date+'&hf_id='+hf_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const shippingSamplesDelete = (id, modal)=>{
    return fetchRequest({
        url:'shipping_samples/'+id,
        method:'DELETE',
        modal:modal,
        message_modal:'Eliminado...'
    });
};

export const shippingSamplesSave = (obj, modal)=>{
    return fetchRequest({
        url:'shipping_samples',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const shippingSamplesSearch = (start_date, end_date, start_folio, end_folio, hf_id, modal)=>{
    return fetchRequest({
        url:'shipping_samples/search?start_date='+start_date+'&end_date='+end_date+'&start_folio='+start_folio+'&end_folio='+end_folio+'&hf_id='+hf_id,
        modal:modal,
        message_modal:'Buscando...'
    });
};

export const specialReports = (obj)=>{
    return fetchRequest({
        url:'special_reports',
        method:'POST',
        obj:obj,
        modal:this.waiting_modal,
        message_modal:'Generando...',
        is_file:true,
    });
};

export const startSessionUserGeneric = (obj)=>{
    return fetchRequest({
        url:'users_generic',
        method:'POST',
        obj:obj,
    });
};

export const traceabilityReprint = (obj)=>{
    return fetchRequest({
        url:'traceabilities/reprint',
        method:'POST',
        obj:obj
    });
};

export const unitAsociation = (id)=>{
    return fetchRequest({
        url:'units_asociation/'+id
    });
};

export const unitAsociationAdded = (id, component)=>{
    return fetchRequest({
        url:'units_asociation?id='+id+'&component_type='+component
    });
};

export const unitAsociationId = (id, modal = null)=>{
    return fetchRequest({
        url:'units_asociation?id='+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const unitAsociationGetComponents = (unit_number, hf_id, id)=>{
    return fetchRequest({
        url:'units_asociation/get_components?unit_number='+unit_number+'&health_facilities_id='+hf_id+'&unit_request_id='+id
    });
};

export const unitAsociationSave = (hf_id, obj, modal)=>{
    return fetchRequest({
        url:'units_asociation?health_facility='+hf_id,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Generando...'
    });
};

export const unitsDistribution = (number)=>{
    return fetchRequest({
        url:'units/distribution?unit_number='+number
    });
};

export const unitEntriesId = (id)=>{
    return fetchRequest({
        url:'unit_entries/'+id
    });
};

export const unitEntriesDelete = (id, modal)=>{
    return fetchRequest({
        url:'unit_entries/'+id,
        method:'DELETE',
        modal:modal,
        message_modal:'Eliminando...'
    });
};

export const unitEntriesForUpdate = (start_date, end_date, hf_id, modal)=>{
    return fetchRequest({
        url:'unit_entries/for_update?start_date='+start_date+'&end_date='+end_date+'&hf_id='+hf_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const unitEntriesMultiple = (obj, modal, method = 'PUT')=>{
    return fetchRequest({
        url:'unit_entries/multiple',
        method:method,
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const unitEntriesNextRelabel = (hf_id)=>{
    return fetchRequest({
        url:'unit_entries/next_relabel?hf_id='+hf_id
    })
}

export const unitEntriesSave = (id = '', obj, modal)=>{
    return fetchRequest({
        url:'unit_entries' + (id === '' ? '' : '/'+id),
        method: id === '' ? 'POST' : 'PUT',
        obj:obj, 
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const unitEntriesSearch = (start_date, end_date, start_folio, end_folio, hf_id, modal)=>{
    return fetchRequest({
        url:'unit_entries?start_date='+start_date+'&end_date='+end_date+'&start_folio='+start_folio+'&end_folio='+end_folio+
            '&health_facilities_id='+hf_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};


export const unitExport = (obj)=>{
    return fetchRequest({
        url:'unit_export',
        method:'POST',
        obj:obj
    });
};

export const unitExportId = (id)=>{
    return fetchRequest({
        url:'unit_export/'+id
    });
};

export const unitExportDelete = (id, obj, modal)=>{
    return fetchRequest({
        url:'unit_export/'+id,
        method:'DELETE',
        obj:obj,
        modal:modal,
        message_modal:'Eliminando...'
    });
};
export const htmlTemplatePrintListaRecurrente = (obj,hf_id)=>{
    return fetchRequest({
        url:'html_templates/printRecurrente/'+hf_id,
        method:'POST',
        obj:obj,
        is_file:true,
    });
};
export const unitExportPartialDelete = (obj)=>{
    return fetchRequest({
        url:'unit_export/partial_delete',
        method:'POST',
        obj:obj
    });
};

export const unitExportSearch = (start_date, end_date, start_folio, end_folio, hf_id, status, modal=null)=>{
    return fetchRequest({
        url:'unit_export?start_date='+start_date+'&end_date='+end_date+'&start_folio='+start_folio+
            '&end_folio='+end_folio+'&health_facilities_id='+hf_id+"&status="+status,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const unitReservedByUnit = (id)=>{
    return fetchRequest({
        url:'unit_reserved/by_unit/'+id,
        method: 'DELETE'
    });
};

export const unitRequest = (id, modal = null)=>{
    return fetchRequest({
        url:'unit_request/'+id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const unitRequestAsociation = (id, obj)=>{
    return fetchRequest({
        url:'unit_request/asociation?unit_request_id='+id,
        method:'POST',
        obj:obj
    });
};

export const unitRequestConfirm = (hf_id, status, units, modal)=>{
    return fetchRequest({
        url:'unit_request/confirm?health_facility='+hf_id+'&status='+status,
        method:'POST',
        obj:units,
        modal:modal,
        message_modal:'Generando...'
    });
};

export const unitRequestDelete = (unit, modal)=>{
    return fetchRequest({
        url:'unit_request/'+unit,
        method:'DELETE',
        modal:modal,
        message_modal:'Borrando...'
    });
};

export const unitRequestSave = (obj, modal)=>{
    return fetchRequest({
        url:'unit_request',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const unitRequestSearch = (start_date, end_date, start_folio, end_folio, option, hf_id, type, status, modal = null)=>{
    return fetchRequest({
        url:'unit_request?start_date='+start_date+'&end_date='+end_date+'&start_folio='+start_folio+
            '&end_folio='+end_folio+'&option='+option+'&health_facilities_id='+hf_id+'&type='+type+'&status='+status,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const unitRequestStatus = (obj, modal)=>{
    return fetchRequest({
        url:'unit_request/status',
        method:'PUT',
        obj:obj,
        modal:modal,
        message_modal:'Cancelando...'
    });
};

export const unitRequestUpdate = (id, obj, modal)=>{
    return fetchRequest({
        url:'unit_request_update/'+id,
        method:'PUT',
        obj:obj,
        modal:modal,
        message_modal:'Guardando...'
    });
};

export const unitsSendUnit = (hf_id, unit_number,location_site)=>{
    return fetchRequest({
        url:'units/send_unit?health_facilities_id='+hf_id+'&unit_number='+unit_number+'&location_site='+location_site
    });
};

export const unitsSendUnitConfirm = (hf_id, unit_number, confirm)=>{
    return fetchRequest({
        url:'units/send_unit?health_facilities_id='+hf_id+'&unit_number='+unit_number+'&confirm_number='+confirm
    });
};

export const unitForTransfer = (number, hf_id)=>{
    return fetchRequest({
        url:'units/unit_for_transfer?number='+number+'&health_facilities_id='+hf_id
    });
};

export const unitForTransferSt = (hf_id, modal)=>{
    return fetchRequest({
        url:'units/unit_for_transfer_st?health_facilities_id='+hf_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const unitTansfer = (obj)=>{
    return fetchRequest({
        url:'unit_transfer',
        method:'POST',
        obj:obj
    });
};

export const unitTransferAllSt = (id, obj)=>{
    return fetchRequest({
        url:'unit_transfer/all_st/'+id,
        method:'PUT',
        obj:obj
    });
};

export const unitTransferDelete = (id, modal)=>{
    return fetchRequest({
        url:'unit_transfer/'+id,
        method:'DELETE',
        modal:modal,
        message_modal:'Eliminando...'
    });
};

export const unitTransferConfirmUnit = (hf_id, number)=>{
    return fetchRequest({
        url:'unit_transfer/confirm_unit?health_facilities_id='+hf_id+'&unit_number='+number
    });
};

export const unitTransferId = (id)=>{
    return fetchRequest({
        url:'unit_transfer/'+id
    });
};

export const unitTransferSearch = (start_date, end_date, status, hf_id, modal)=>{
    return fetchRequest({
        url:'unit_transfer?start_date='+start_date+'&end_date='+end_date+'&status='+status+'&health_facilities_id='+hf_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const unitTransferUpdate = (id, obj)=>{
    return fetchRequest({
        url:'unit_transfer/'+id,
        method:'PUT',
        obj:obj
    });
};

export const usersVerifyPass = (obj, modal)=>{
    return fetchRequest({
        url:'users/verify_pass',
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Autorizando...'
    });
};

export const validatorGetResults = (hf_id, sample_id, modal)=>{
    return fetchRequest({
        url:'validator/get_results?hf_id='+hf_id+'&sample_id='+sample_id,
        modal:modal,
        message_modal:'Cargando...'
    });
};

export const validator = (sample_id, hf_id, obj, modal = null)=>{
    return fetchRequest({
        url:'validator?sample_id='+sample_id+'&hf_id='+hf_id,
        method:'POST',
        obj:obj,
        modal:modal,
        message_modal:'Validando...'
    });
};

export const validatorDelete = (sample_id, hf_id, obj, modal)=>{
    return fetchRequest({
        url:'validator?samples_id='+sample_id+'&hf_id='+hf_id,
        method:'DELETE',
        obj:obj,
        modal:modal,
        message_modal:'Eliminado Validación...'
    })
}

export const workSessions = (id)=>{
    return fetchRequest({
        url:'work_sessions/'+id
    });
};

export const workSessionsOption = (hf_id)=>{
    return fetchRequest({
        url:'work_sessions/?option=&health_facilities_id='+hf_id
    });
};